module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJpY24tZG90LWZpbGwiPgo8cGF0aCBpZD0iVW5pb24iIGQ9Ik02IDQuODc1QzYuNjIxMzIgNC44NzUgNy4xMjUgNS4zNzg2OCA3LjEyNSA2QzcuMTI1IDYuNjIxMzIgNi42MjEzMiA3LjEyNSA2IDcuMTI1QzUuMzc4NjggNy4xMjUgNC44NzUgNi42MjEzMiA0Ljg3NSA2QzQuODc1IDUuMzc4NjggNS4zNzg2OCA0Ljg3NSA2IDQuODc1WiIgZmlsbD0iIzRFNTk2OCIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/icn_dot_fill.svg
// module id = ZFkQ
// module chunks = 1